import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { IUiConfig } from '../../types/uiConfig';
import { API_INTERACT_URL, axiosInt } from '../../';

export const FETCH_PUBLIC_UI_CONFIG_KEY = 'public-ui-config';

export const fetchPublicUiConfigApi = async (): Promise<IUiConfig> => {
  const response = await axiosInt.get<IUiConfig>(`${API_INTERACT_URL}/public/ui-config`);
  return response.data;
};

const usePublicUiConfig = (options?: Partial<UseQueryOptions<IUiConfig>>) => {
  const {
    data: uiConfig,
    isLoading: isLoadingUiConfig,
    error: errorFetchingUiConfig,
  } = useQuery<IUiConfig>({
    queryKey: [FETCH_PUBLIC_UI_CONFIG_KEY],
    queryFn: fetchPublicUiConfigApi,
    staleTime: 5 * 60 * 1000,
    ...options,
  });

  return { uiConfig, isLoadingUiConfig, errorFetchingUiConfig };
};

export default usePublicUiConfig;
